var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 34,
    height: 34,
    fill: "url(#pattern0_458_3528)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_458_3528",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_458_3528",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_458_3528",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADB0lEQVR4nO3dvWoUURiH8UG7RfxotM01SOzUqOBHLiA3EKzSaqcGW7Gyilib5lyDpjB2fqF4CSpqGxFE8JGDM2RZ5+zOJrPnfWfm/8BC2LAzc84v5ySE7KQolFJK5Qq4AjwqH5c184YBt4E/7Bc/viUUG4wzwC/+Lz53Wij5QVZJtyqQ/CBrU0DWBCKQYYdWiK8QiK8QiK8QiK8QiK8QiK8QiK8QiK8QiK8QiK8QSHJiTgKbwFvgB/kKU7BCxuuIY34D3ItzUVgGXAK+Y1NwAjLeN2Alr8L+oM8BP7ErOAShnJPl3BhHgY/YFpyCxD7EOcoJcgP7gmOQ2LWcIA+tR4t/kAc5QbatR4t/kO2cIB4GHLp6fQKxSSBVWiHOvgLRliWQmrRlVWmF2BSKRAIRSF3asqq0QmwKRSKBCKQubVlVWiE2hSKRQARSl7asKq0Qm0KRSCACqUtbVpVWiE2hSCQQgdSlLatKK8SmUCQSiEDq0pZVpRViUygSCUQgvdyyfgNbwHr55pfPC1whn8pzxHM9Ls/ddp0GiRNyvuadWTsHGfCM69uZfKcTcGEBKJ0G2UqcZzQF5SAg8VijxGuetDymToOsTznXKIEyL0gSo3zNzZbH1GmQzRnnG9WgzAMyFaN8zf2Wx9RpkC/AqQYoz5oMeOL6XgDHZhz7RPmNvs06DdJ04kZjKE1Amh7z+QLG03mQeVFmgVhi9Aak6X4fJ3Jjyuc3Gh5j2o/Vh603IDT56j7k9S9yZfQSZGEomTB6CdI6SkaM3oK0hpIZo9cgsd3DoBhg9B7kwChGGIMAmRvFEGMwII1RjDEGBTITxQHG4ECSKE4wBgkSewksjV3XUvmchwYJUt1Sb7d8WN5ycLLBgnhNIM4SiLME4iyBOEsgzhKIswTiLIEMGcTDjZS993Rotxr3XtZbjV+3Hm0HupoT5AjwznrEjnsf5ygbSImy7Oy3q16Kc3I2K8YYykr5b37Uv74CF00wJv6U/y7wGthjeO0Br4A7wHFTDKWUUkoppZRSShXt9hfvcxjZLEi+mgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.aa1b05532e0e6bad65e84fb64c1d7675.svg";
export { ForwardRef as ReactComponent };